import { c as _c } from "react/compiler-runtime";
import { CurrencyLockup } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Item, ItemTitle } from "@opensea/next-ui-kit";
import { classNames, FlexCenter, FlexColumn, StatChange, TextOverflowTooltip } from "@opensea/ui-kit";
import { CurrencyLink } from "@/components/currencies/CurrencyLink";
import { CurrencyPrice } from "@/components/currencies/CurrencyPrice";
import { CurrencySparkLineChart } from "@/components/currencies/charts/CurrencySparkLineChart";
import { expandedSearchHoverStyles, expandedSearchSelectedStyles } from "./constants";
import { ExpandedSearch_currencyFragment } from "./ExpandedSearch.fragment";
export function ExpandedSearchTrendingCurrencyCard(t0) {
  const $ = _c(31);
  const {
    currency: currencyKey,
    className,
    onSelect,
    selected: t1,
    onPointerEnter
  } = t0;
  const selected = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== currencyKey) {
    t2 = readFragment(ExpandedSearch_currencyFragment, currencyKey);
    $[0] = currencyKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const currency = t2;
  const t3 = selected && expandedSearchSelectedStyles;
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = classNames("flex h-16 w-full items-center justify-center rounded-lg border bg-bg-primary p-3 shadow-xs", expandedSearchHoverStyles, t3, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== currency) {
    t5 = <CurrencyLockup currency={currency} size="sm" />;
    $[5] = currency;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== currency.name) {
    t6 = <Item variant="unstyled"><TextOverflowTooltip><ItemTitle className="truncate font-medium text-sm">{currency.name}</ItemTitle></TextOverflowTooltip></Item>;
    $[7] = currency.name;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== currency) {
    t7 = <div className="text-sm text-text-secondary"><CurrencyPrice currency={currency} /></div>;
    $[9] = currency;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== currency.stats) {
    t8 = currency.stats?.oneDay?.priceChange !== undefined && currency.stats?.oneDay?.priceChange !== 0 && <StatChange change={currency.stats.oneDay.priceChange} className="text-sm" />;
    $[11] = currency.stats;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <FlexCenter className="gap-2">{t7}{t8}</FlexCenter>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <FlexColumn className="min-w-0 flex-1 overflow-hidden">{t6}{t9}</FlexColumn>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== currency) {
    t11 = <div className="h-8 w-14 shrink-0"><CurrencySparkLineChart className="pointer-events-none h-full w-full" currency={currency} showTooltip={false} timeframe="ONE_DAY" /></div>;
    $[19] = currency;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t5) {
    t12 = <FlexCenter className="w-full gap-3">{t5}{t10}{t11}</FlexCenter>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t5;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== currency || $[26] !== onPointerEnter || $[27] !== onSelect || $[28] !== t12 || $[29] !== t4) {
    t13 = <CurrencyLink className={t4} currency={currency} onClick={onSelect} onPointerEnter={onPointerEnter}>{t12}</CurrencyLink>;
    $[25] = currency;
    $[26] = onPointerEnter;
    $[27] = onSelect;
    $[28] = t12;
    $[29] = t4;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}